import React, { useState } from 'react'
import { Divider, Image, Link, SectionTitle, Typography } from '../base-ui'
import { WidgetList } from '.'
import { css, useTheme } from '@emotion/react'
import { generateUrl } from '../../utils'
import { posterSrc, thumbnailSrc } from '../../utils/news'

const filterCss = css`
    border: 1px solid #dccdfc;
    padding: 0.125rem 0.5rem;
    color: #492acd;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    & > label {
        font-size: 14px;
        cursor: pointer;
    }
`
const latestnewsTitleStyle = css`
padding: 0.5rem;
display: inline-flex;
gap: 0.5rem;
margin-bottom: 0;
flex: 1;
`

function LatestPostsFilter({ initNews = [], services = [], title }) {
    const theme = useTheme()

    const sortedServices = services?.sort((a, b) => a.position - b.position)
    const [activeTab, setActiveTab] = useState(sortedServices?.[0]?.id)
    if (!services?.length) return null
    return (
        <div style={{
            backgroundColor: '#fff',
            boxShadow: theme.boxShadow.default,
            borderTop: `3px solid ${theme.colors.primary}`,
            borderRadius: 6
        }}>
            <SectionTitle color="primary" dividerColor="lightGray" style={{ backgroundColor: theme.colors.white }}>{title}</SectionTitle>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: 10,
                alignItems: 'center',
                borderBottom: '1px dashed #dddddd',
                fontSize: 16,
                padding: '0 16px 16px 16px',
            }}>
                {services.map((service) => {
                    return <div
                        style={{
                            backgroundColor: activeTab === service.id
                                ? '#492acd'
                                : '#f1edfe',
                            color: activeTab === service.id
                                ? '#fff'
                                : '#492acd',
                        }}
                        css={filterCss}
                        onClick={() => { setActiveTab(service.id) }}
                        key={service.id}>
                        <label
                            key={service.id}
                            htmlFor="video"
                        >
                            {service.title}
                        </label>
                    </div>
                })}
            </div>
            <WidgetList
                widget={initNews?.[Number(activeTab)]?.news}
                css={css`
                    .card-title {
                        margin-bottom: 0 !important;
                    }
                `}
                listStyle={{ gap: 0 }}
                divider={<Divider gap="0" />}
                filterItem={false}
                itemRender={({ post }) => (
                    <Link href={generateUrl(post, 'news')}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative',
                            padding: '5px 5px 0',
                        }}>
                            <div style={{ height: 40, width: 60, position: 'relative', }}>
                                <Image width={60} height={40} objectFit="cover" src={post.media ? posterSrc(post.media) : thumbnailSrc(post.thumbnail)}
                                    alt={post.thumbnail?.alt ?? post?.title} />
                            </div>
                            <Typography type="h4" fontSize="0.9rem" css={latestnewsTitleStyle}
                                hoverColor="primary">
                                {post.title}
                            </Typography>
                        </div>
                    </Link>
                )}
            />
        </div>
    )
}

export default LatestPostsFilter
